import Swiper from 'swiper'
import { A11y, Navigation, Pagination } from 'swiper/modules'

const setupRelatedPosts = (el) => {
  const container = el.querySelector('.swiper')

  const opts = {
    modules: [A11y],
    slidesPerView: 'auto',
    speed: 500,
  }

  if (el.querySelector('.slider-controls')) {
    opts.modules.push(Navigation)
    opts.modules.push(Pagination)
    opts.navigation = {
      nextEl: el.querySelector('.slider-button-next'),
      prevEl: el.querySelector('.slider-button-prev'),
    }
    opts.pagination = {
      el: el.querySelector('.slider-pagination'),
      clickable: true,
    }
  }

  new Swiper(container, opts)
}

const relatedPosts = document.querySelector('.news-related-posts')

if (relatedPosts) {
  setupRelatedPosts(relatedPosts)
}
